import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from 'src/app/models/user';
import { TokenStorage } from '../../core/token-storage';
import { OrganizationsService } from '../organizations.service';
import { UsersService } from '../users.service';
import { ExternalResponse } from 'src/app/models/external-response';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
    private CESAR_ACCESS_TOKEN = '__access_token__';
    private RESPONSE = 'response';

    constructor(
        private router: Router,
        private usersService: UsersService,
        private organizationsService: OrganizationsService,
        private tokenStorage: TokenStorage,
        private toastrService: ToastrService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        var ssoToken = next.queryParams[this.CESAR_ACCESS_TOKEN];

        if (ssoToken) {
            // Initialise les éventuels données en session
            this.usersService.removeCurrentUser();

            console.log("Checking token '" + ssoToken + "'");

            // Verifie sur le serveur si le token est correct.
            return this.usersService.checkCurrentUser(ssoToken).pipe(
                map(
                    (x) => {
                        let currentUser = x;

                        if (currentUser) {
                            // Enregistre le token
                            this.tokenStorage.saveToken(ssoToken);

                            // Par défaut l'organisation en cours d'administration est celle de l'utilisateur connecté
                            this.organizationsService.getOrganisation(currentUser.organizationId).subscribe((x) => {
                                this.organizationsService.setCurrentOrganization(x);
                            });

                            // Redirige vers la page demandée en enlevant le paramètre du token
                            const params = { ...next.queryParams };
                            delete params[this.CESAR_ACCESS_TOKEN];
                            this.router.navigate([state.url.substring(0, state.url.indexOf('?'))], { queryParams: params });

                            return true;
                        } else {
                            this.router.navigate(['/login']);
                            return false;
                        }
                    },
                    (error) => {
                        this.router.navigate(['/login']);
                        return false;
                    }
                )
            );
        } else {
            if (next.queryParams[this.RESPONSE]) {
                const response = JSON.parse(next.queryParams[this.RESPONSE]) as ExternalResponse;

                if (response) {
                    if (response.code === 200) {
                        this.toastrService.success(response.message, '', { enableHtml: true });
                    } else {
                        this.toastrService.warning(response.message, '', { enableHtml: true });
                    }
                }

                this.router.navigate([]);
            }

            let currentUser = this.usersService.getSessionCurrentUser();

            if (currentUser) {
                return true;
            } else {
                // Initialise les éventuels données en session
                this.usersService.removeCurrentUser();

                this.router.navigate(['/login']);
                return false;
            }
        }
    }
}
